import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { DeleteMerch } from '@webapp/store/merch/action-creators';
import { DELETE_MERCH } from '@webapp/store/merch/actions';
import AppState from '@webapp/store/state';

export const merchProductTakeDown = (action$: Observable<DeleteMerch>, state$: Observable<AppState>) =>
    action$.pipe(
        ofType(DELETE_MERCH),
        withLatestFrom(state$),
        map(([action, state]) => {
            if (window.analytics) {
                const curretMerch = state.merch.artistMerch.find(m => m.id === action.productId)
                window.analytics.track('Products Takedown', {
                    product_id: action.productId,
                    variants: curretMerch?.variants,
                    price: curretMerch?.price,
                    cost: curretMerch?.cost
                })
            }
        }),
        filter(() => false)
    )